module.exports = __webpack_public_path__ + "media/images/review-96e0db12b50c8aea9e45b7e438c741caf4f37d1baf56157bb1875e7c04209e1d.jpg";